<template>
    <div v-if="this.isLoaded"  class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <!-- 本人確認手続き タイトル start -->
        <div class="text-center p-2">
            <h3 class="fontSize1">{{ $t('kyc.settings.title') }}</h3>
            <h3 class="fontSize1 titleSub">{{ $t('kyc.titleSub') }}</h3>
        </div>
         <!-- 本人確認手続き タイトル end -->

        <!-- 本人確認状況 start -->
        <div class="centering_item1">
            <div class="menu1">
                <div class="kyc_label_top" v-bind:class="isLang? jaClass : enClass" v-html="$t('kyc.message.titleLabel')"></div>
                <div v-if="this.kycStatus == this.kyc_settings_empty" class="kyc_status1"></div>
                <div v-if="this.kycStatus != this.kyc_settings_empty" class="kyc_status1">{{ $t(`kyc.message.kycStatuses[${kycStatus}]`)}}</div>
            </div>
        </div>
        <!-- 本人確認状況 end -->

        <!-- 本人確認(KYC)とは start -->
        <div class="kyc-Manual1">
            <div class="text-center delete-updown fontSize1">
                {{ $t('kyc.message.manual.manual1') }}
            </div>
            <div class="border-line"></div>
        </div>
        <div class="kyc-Manual2">
            <div class="text-center delete-updown">
                {{ $t('kyc.message.manual.manual2') }}
            </div>
            <div class="text-center delete-updown">
                {{ $t('kyc.message.manual.manual3') }}
            </div>
            <div class="text-center delete-updown">
                {{ $t('kyc.message.manual.manual4') }}
            </div>
             <div v-if="this.langs" class="text-center delete-updown">
                {{ $t('kyc.message.manual.manual5') }}
            </div>
        </div>
         <!-- 本人確認(KYC)とは end -->

        <!-- 本人確認手続きはかんたん4つのステップ タイトル start -->
        <div class="text-center p-2">
            <div class="text-center delete-updown fontSize1">
                {{ $t('kyc.message.stepImg.manual1') }}
                <span v-if="this.langs">{{ $t('kyc.message.stepImg.manual2') }}</span>
            </div>
            <div class="border-line"></div>
        </div>
        <!-- 本人確認手続きはかんたん4つのステップ タイトル end -->

        <!-- 本人確認手続きはかんたん4つのステップ 画像 start -->
        <div class="centering_item3">
            <div class="menu3">
                <ul v-if="!this.langs" class="kyc_label"><p>{{ $t('kyc.message.stepImg.step1.label') }}</p></ul>
                <ul v-if="this.langs" class="kyc_labelE1"><p>{{ $t('kyc.message.stepImg.step1.label') }}</p></ul>
                <ul class="kyc_status2"><p>{{ $t('kyc.message.stepImg.step1.manual') }}</p></ul>
            </div>

            <div class="menu5">
                <div class="outer">
                    <div class="inner" style="max-width: 70%;">
                        <img :src="idImageStepData1"/>
                    </div>
                </div>
            </div>

            <div class="menu3 menu4">
                <ul v-if="!this.langs" class="kyc_label" ><p>{{ $t('kyc.message.stepImg.step2.label') }}</p></ul>
                <ul v-if="this.langs" class="kyc_labelEall" ><p>{{ $t('kyc.message.stepImg.step2.label') }}</p></ul>
                <ul class="kyc_status2"><p>{{ $t('kyc.message.stepImg.step2.manual') }}</p></ul>
            </div>

            <div class="menu5">
                <div class="outer">
                    <div class="inner" style="max-width: 70%;">
                        <img :src="this.idImageStepData2"/>
                    </div>
                </div>
            </div>

            <div class="menu3 menu4">
                <ul v-if="!this.langs" class="kyc_label" style="margin-top: -1px;"><p>{{ $t('kyc.message.stepImg.step3.label') }}</p></ul>
                <ul v-if="this.langs" class="kyc_labelEall" ><p>{{ $t('kyc.message.stepImg.step3.label') }}</p></ul>
                <ul class="kyc_status2"><p v-html="$t('kyc.message.stepImg.step3.manual')"></p></ul>
            </div>

            <div class="menu5">
                <div class="outer">
                    <div class="inner" style="max-width: 70%;">
                        <img :src="this.idImageStepData3"/>
                    </div>
                </div>
            </div>

            <div class="menu3 menu4">
                <ul v-if="!this.langs" class="kyc_label"　style="margin-top: -1px;"><p>{{ $t('kyc.message.stepImg.step4.label') }}</p></ul>
                <ul v-if="this.langs" class="kyc_labelE4"><p>{{ $t('kyc.message.stepImg.step4.label') }}</p></ul>
                <ul class="kyc_status2"><p>{{ $t('kyc.message.stepImg.step4.manual') }}</p></ul>
            </div>

            <div class="menu5">
                <div class="outer">
                    <div class="inner" style="max-width: 70%;">
                        <img :src="this.idImageStepData4"/>
                    </div>
                </div>
            </div>
        </div>
       <!-- 本人確認手続きはかんたん4つのステップ 画像 end -->

        <!-- 申請するときの注意点 start -->
        <div class="caution">
            <div class="text-center p-2">
                <div class="kyc-Manual1">
                    <div class="text-center delete-updown">
                        <div class="fontSize2">{{ $t('kyc.message.caution.cautionTitle') }}</div>
                    </div>
                    <div class="border-line"></div>
                </div>
            </div>

            <div class="centering_item4">
                <div class="delete-updown caution-manual menu2">
                    {{ $t('kyc.message.caution.caution0') }}
                </div>
                <div class="centering_item1">
                    <div class="menu2">
                        <ul class="cation-label">{{ $t('kyc.message.caution.caution1.no') }}</ul>
                        <ul>{{ $t('kyc.message.caution.caution1.label') }}</ul>
                    </div>
                    <div class="menu2">
                        <ul class="cation-label">{{ $t('kyc.message.caution.caution2.no') }}</ul>
                        <ul>{{ $t('kyc.message.caution.caution2.label') }}</ul>
                    </div>
                    <div class="menu2">
                        <ul class="cation-label">{{ $t('kyc.message.caution.caution3.no') }}</ul>
                        <ul>{{ $t('kyc.message.caution.caution3.label') }}</ul>
                    </div>
                    <div class="menu2">
                        <ul class="cation-label">{{ $t('kyc.message.caution.caution4.no') }}</ul>
                        <ul>{{ $t('kyc.message.caution.caution4.label') }}</ul>
                    </div>
                    <div class="menu2">
                        <ul class="cation-label">{{ $t('kyc.message.caution.caution5.no') }}</ul>
                        <ul>{{ $t('kyc.message.caution.caution5.label') }}</ul>
                    </div>
                    <div class="menu2">
                        <ul class="cation-label">{{ $t('kyc.message.caution.caution6.no') }}</ul>
                        <ul>{{ $t('kyc.message.caution.caution6.label') }}</ul>
                    </div>
                    <div class="menu2">
                        <ul class="cation-label">{{ $t('kyc.message.caution.caution7.no') }}</ul>
                        <ul>{{ $t('kyc.message.caution.caution7.label') }}</ul>
                    </div>
                    <div class="menu2">
                        <ul class="cation-label">{{ $t('kyc.message.caution.caution8.no') }}</ul>
                        <ul>{{ $t('kyc.message.caution.caution8.label') }}</ul>
                    </div>
                    <div class="menu2">
                        <ul class="cation-label">{{ $t('kyc.message.caution.caution9.no') }}</ul>
                        <ul>{{ $t('kyc.message.caution.caution9.label') }}</ul>
                    </div>
                    <div class="menu2">
                        <ul class="cation-label">{{ $t('kyc.message.caution.caution10.no') }}</ul>
                        <ul class="pre">{{ $t('kyc.message.caution.caution10.label') }}</ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 申請するときの注意点 end -->

        <div class="custom-select-wrapper mx-auto mb-5">
            <select class="custom-select custom-select-purple" v-model="formData.type" :disabled="this.status == this.kyc_settings_confirm || this.status == this.kyc_settings_re_upload">
                <option :value=null>{{ $t('kyc.select') }}</option>
                <option :selected="formData.type == t.id" v-for="t in types" :key="t.id" :value="t.id" >{{ $t('kyc.types.' + t.name) }}</option>
            </select>

            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#7b2cbf" stroke-width="3">
                <path d="M6 9l6 6 6-6"/>
            </svg>
        </div>

        <!-- 本人確認を申請する start -->
        <div class="centering_item1" id="color-confirm" style="padding-top: 10px; padding-bottom: 20px; background-color: #fff;">

            <div class="text-center col-text apply"><p class="titleSubLabel">{{ $t('kyc.message.titleSubLabel') }}</p></div>
            <form enctype="multipart/form-data" @submit.prevent="handleOnSubmit">

 	            <div class="form-group" style="text-align:center;">
                    <!-- 本人確認ステータス「本人確認写真のアップロードが必要です」 「非承認です。再度写真をアップロードしてください。」の場合-->
                    <div v-if="this.status == this.kyc_settings_upload || this.status == this.kyc_settings_non_approval" class="outer chkImage1">

                        <div class="document-preview text-center">
                            <!-- 画像アップロード(前)に表示する画像 -->
                            <img :src="idImageData1" style="background-color: #fff; border: 2px solid #c6c6c6;"/>
                            <div v-if="errors['files.file1'] && formData.type == TYPE_KYC_DRIVER_LICENSE" class="fontSizeErr mt-2">{{ $t('errors.' + errors['files.file1']) }}</div>
                        </div>
                    </div>
                     <!-- 本人確認ステータス「本人確認写真を確認中です」 「再アップロード済み」の場合-->
                    <div v-if="this.status == this.kyc_settings_confirm || this.status == this.kyc_settings_re_upload" class="outer chkImage2 colorfilter-base">

                        <img :src="idImageData1" class="colorfilter-image" style="background-color: #fff; border: 2px solid #c6c6c6;"/>
                        <!-- 画像アップロード(後)に表示する画像 -->
                        <p class="inner text_area">{{ $t('kyc.message.checkImg') }}</p>
                    </div>
                    <div v-if="formData.type == TYPE_KYC_ID_CARD" class="text-danger fw-bold pre mt-2">{{ $t('kyc.notice_id_card') }}</div>
                    <div v-if="formData.type == TYPE_KYC_ID_CARD" class="text-primary fw-bold pre mt-2">{{ $t('kyc.note_id_card') }}</div>

                    <!-- 本人確認ステータス「本人確認写真のアップロードが必要です」 「非承認です。再度写真をアップロードしてください。」の場合-->
                    <div v-if="this.status == this.kyc_settings_upload || this.status == this.kyc_settings_non_approval" class="d-flex flex-column align-items-center justify-content-center">

                        <div class="form-group upload-btn-wrapper text-center mt-4" style="margin-bottom: 0px;">
                            <!-- ボタン：写真をアップロード -->
                            <button type="button" :class="formData.type == null ? 'btn-disabled' : ''" class="btn btn-outline-secondary col-text btn-size" style="padding-left: 1px; background-color: #fff; border: 2px solid #7D34AD;">
                                <img class="img-btn" :src="idImageBtn"/>{{ $t('kyc.upload') }}
                            </button>
                            <!-- ファイル選択 -->
                            <input ref="file1"
                                @change="handleOnChangeFileInput($event, 'file1')"
                                placeholder="Upload ID picture"
                                type="file"
                                accept="image/*"
                                class="form-control"
                                v-bind:class="{ 'is-invalid': errors.file}"
                                :disabled="formData.type == null"
                                >
                        </div>
                    </div>

                    <div v-if="this.status == this.kyc_settings_confirm || this.status == this.kyc_settings_re_upload">
                        <div class="form-group upload-btn-wrapper text-center my-4" style="margin-bottom: 0px;">
                            <label>
                            <button type="button" class="btn btn-outline-secondary col-text btn-size btn-disabled" style="padding-left: 1px; background-color: #c6c6c6;" disabled>
                                <img class="img-btn" :src="idImageBtn"/>{{ $t('kyc.upload') }}
                            </button>
                            </label>
                        </div>
                    </div>

                    <div v-if="formData.type == TYPE_KYC_DRIVER_LICENSE" class="text-primary font-bold pre mt-2 px-5">{{ $t('kyc.note_driver_license') }}</div>

                    <div v-if="(this.status == this.kyc_settings_upload || this.status == this.kyc_settings_non_approval) && formData.type == TYPE_KYC_DRIVER_LICENSE && formData.files.file2 != null" class="outer chkImage1 pt-4">

                        <div class="document-preview text-center">
                            <!-- 画像アップロード(前)に表示する画像 -->
                            <img :src="idImageData2" style="background-color: #fff; border: 2px solid #c6c6c6;"/>
                            <div v-if="errors['files.file2'] && formData.type == TYPE_KYC_DRIVER_LICENSE" class="fontSizeErr mt-2">{{ $t('errors.' + errors['files.file2']) }}</div>
                        </div>
                    </div>
                     <!-- 本人確認ステータス「本人確認写真を確認中です」 「再アップロード済み」の場合-->
                    <div v-if="(this.status == this.kyc_settings_confirm || this.status == this.kyc_settings_re_upload) && formData.type == TYPE_KYC_DRIVER_LICENSE" class="outer chkImage2 colorfilter-base">

                        <img :src="idImageData2" class="colorfilter-image" style="background-color: #fff; border: 2px solid #c6c6c6;"/>
                        <!-- 画像アップロード(後)に表示する画像 -->
                        <p class="inner text_area">{{ $t('kyc.message.checkImg') }}</p>
                    </div>

                    <!-- 本人確認ステータス「本人確認写真のアップロードが必要です」 「非承認です。再度写真をアップロードしてください。」の場合-->
                    <div v-if="(this.status == this.kyc_settings_upload || this.status == this.kyc_settings_non_approval) && formData.type == TYPE_KYC_DRIVER_LICENSE" class="d-flex flex-column align-items-center justify-content-center">

                        <div class="form-group upload-btn-wrapper text-center mt-4" style="margin-bottom: 0px;">
                            <!-- ボタン：写真をアップロード -->
                            <button type="button" :class="formData.type == null ? 'btn-disabled' : ''" class="btn btn-outline-secondary col-text btn-size" style="padding-left: 1px; background-color: #fff; border: 2px solid #7D34AD;">
                                <img class="img-btn" :src="idImageBtn"/>{{ $t('kyc.upload') }}
                            </button>
                            <!-- ファイル選択 -->
                            <input ref="file2"
                                @change="handleOnChangeFileInput($event, 'file2')"
                                placeholder="Upload ID picture"
                                type="file"
                                accept="image/*"
                                class="form-control"
                                v-bind:class="{ 'is-invalid': errors.file}"
                                >
                        </div>
                    </div>

                    <!-- 本人確認ステータス「本人確認写真のアップロードが必要です」 「非承認です。再度写真をアップロードしてください。」の場合-->
                    <div v-if="this.status == this.kyc_settings_upload || this.status == this.kyc_settings_non_approval">
                        <!-- エラーメッセージ表示箇所「写真アップロードボタン下」：　画像 -->
                        <div v-if="errors.input_file" class="fontSizeErr">{{ $t('errors.' + errors.input_file) }}</div>
                        <!-- エラーメッセージ表示により表示箇所がズレない処置「写真アップロードボタン下」：　画像 -->
                        <div v-if="!errors.input_file" style="visibility: hidden;" class="fontSizeErr">err</div>
                    </div>

                    <!-- 本人確認ステータス「本人確認写真を確認中です」 「再アップロード済み」の場合-->
                    <div v-if="(this.status == this.kyc_settings_confirm || this.status == this.kyc_settings_re_upload) && formData.type == TYPE_KYC_DRIVER_LICENSE">
                        <div class="form-group upload-btn-wrapper text-center mt-4" style="margin-bottom: 0px;">
                            <label>
                            <button type="button" class="btn btn-outline-secondary col-text btn-size btn-disabled" style="padding-left: 1px; background-color: #c6c6c6;" disabled>
                                <img class="img-btn" :src="idImageBtn"/>{{ $t('kyc.upload') }}
                            </button>
                            </label>
                        </div>
                    </div>

                    <!-- 本人確認ステータス「本人確認写真を確認中です」 「再アップロード済み」の場合-->
                    <div v-if="this.status == this.kyc_settings_confirm || this.status == this.kyc_settings_re_upload">

                        <div v-if="errors.passport_number" class="invalid-feedback">{{ $t('errors.' + errors.passport_number) }}</div>

                        <div v-if="errors.file" class="fontSizeErr">{{ $t('errors.' + errors.file) }}</div>
                        <div v-if="!errors.file" style="visibility: hidden;" class="fontSizeErr">err</div>
                    </div>
                </div>

                <div v-if="formData.type == TYPE_KYC_ID_CARD" class="center col-text how-to2 pre mb-3">{{ $t('kyc.id_card') }}</div>
                <div v-else="formData.type == TYPE_KYC_ID_CARD" class="center col-text how-to2 pre mb-3">{{ $t('kyc.passport') }}</div>
                <div class="center">
                    <input type="text" :disabled="formData.type == null || formData.type == TYPE_KYC_ID_CARD" v-model="formData.passport_number" class="center form-control1" id="passportVal" @input="onInput" style="width: 200px;">
                </div>

                <!-- 本人確認ステータス「本人確認写真のアップロードが必要です」 「非承認です。再度写真をアップロードしてください。」の場合-->
                <div v-if="this.status == this.kyc_settings_upload || this.status == this.kyc_settings_non_approval">
                    <div class="text-center checkbox">
                        <label><input type="checkbox" :disabled="formData.type == null" id="checkout" v-model="chk" @click="clicked(chk)">{{ $t('kyc.message.upload') }}</label>
                    </div>

                    <div>
                        <!-- エラーメッセージ -->
                        <div v-if="errors['files.file1'] && formData.type != TYPE_KYC_DRIVER_LICENSE" class="fontSizeErr aaa">{{ $t('errors.' + errors['files.file1']) }}</div>
                        <div v-if="typeof(errors.files) == 'string' && !errors['files.file1'] && !errors['files.file2']" class="fontSizeErr sss">{{ $t('errors.' + errors['files']) }}</div>
                        <div v-if="errors.passport_number" class="fontSizeErr" style="margin-bottom: 10px;">{{ $t('errors.' + errors.passport_number) }}</div>
                        <div v-if="!errors.file" style="visibility: hidden; " class="fontSizeErr">{{ $t('errors.FILE_SHOULD_NOT_EMPTY') }}</div>
                        <div v-if="!errors.passport_number" style="visibility: hidden; margin-bottom: 10px;"　class="fontSizeErr">{{ $t('errors.PASSPORT_NUMBER_INVALID') }}</div>
                    </div>

                    <div class="text-center">
                        <!-- 送信 -->
                        <button type="submit" id="disabledChk" class="chkCol" v-on:mouseover="mouseOverAction" v-on:mouseleave="mouseLeaveAction" disabled>
                            {{$t('kyc.submit')}}
                        </button>
                    </div>
                </div>

                <!-- 本人確認ステータス「本人確認写真を確認中です」 「再アップロード済み」の場合-->
                <div v-if="this.status == this.kyc_settings_confirm || this.status == this.kyc_settings_re_upload">

                    <div class="text-center checkbox">
                        <label><input type="checkbox" disabled>{{ $t('kyc.message.upload') }}</label>
                    </div>

                    <div v-if="!this.errorsFile" style="visibility: hidden;" class="fontSizeErr">{{ $t('errors.FILE_SHOULD_NOT_EMPTY') }}</div>

                    <div v-if="!this.errorsPassportNumber" style="visibility: hidden; margin-bottom: 10px" class="fontSizeErrEnd">{{ $t('errors.PASSPORT_NUMBER_INVALID') }}</div>

                    <div class="text-center">
                        <button type="submit" id="disabledChk" class="chkCol" disabled>
                            {{$t('kyc.submit')}}
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <!-- 本人確認を申請する end -->

    </div>
</template>

<script>
    import image from './img/image.png';
    import idStep1 from './img/id-step1.png';
    import idStep2ja from './img/id-step2ja.png';
    import idStep2en from './img/id-step2en.png';
    import idStep3 from './img/id-step3.png';
    import idStep4ja from './img/id-step4ja.png';
    import idStep4en from './img/id-step4en.png';
    import btn from './img/btn.png';
    import kycService from '../../services/KycService';
    import config from '../../../config';
    import languageService from '../../services/LanguageService';
    import { KYC_SETTINGS_UPLOAD, KYC_SETTINGS_CONFIRM, KYC_SETTINGS_APPROVAL, KYC_SETTINGS_NON_APPROVAL, KYC_SETTINGS_RE_UPLOAD,
            KYC_COLOR_PURPLE, KYC_COLOR_DARK_PURPLE, KYC_COLOR_DEEP_PURPLE, KYC_COLOR_GRAY, KYC_COLOR_WHITE,
            KYC_ASTERISK_NUM, KYC_SETTINGS_EMPTY, TYPE_KYC_PASSPORT, TYPE_KYC_DRIVER_LICENSE, TYPE_KYC_ID_CARD} from '../../utils/Const';
    export default {
        name: 'kyc-settings',

        components: {
        },

        data() {
            return {
                TYPE_KYC_PASSPORT, TYPE_KYC_DRIVER_LICENSE, TYPE_KYC_ID_CARD,
                errors: this.getDefaultFields(),
                formData: this.getDefaultFields(),
                status: '',
                idImageData1: image,
                idImageData2: image,
                idImageStepData1:   idStep1,
                idImageStepData2: '',
                idImageStepData3:   idStep3,
                idImageStepData4: '',
                idImageBtn: btn,
                idImageUpData: true,
                disabled: false,
                chk: false,
                errorsPassportNumber: false,
                errorsFile: false,
                errorskycFileSizeMax: false,
                errorskycFileExt: false,
                pos: '',
                ext: '',
                fileSize: '',
                langs: '',
                kycStatus: KYC_SETTINGS_EMPTY,
                kyc_settings_upload: KYC_SETTINGS_UPLOAD,
                kyc_settings_confirm: KYC_SETTINGS_CONFIRM,
                kyc_settings_approval: KYC_SETTINGS_APPROVAL,
                kyc_settings_non_approval: KYC_SETTINGS_NON_APPROVAL,
                kyc_settings_re_upload: KYC_SETTINGS_RE_UPLOAD,
                kyc_settings_empty: KYC_SETTINGS_EMPTY,
                getStatus: false,
                resultStatus: '',
                resultData: '',
                isLoaded: false,
                isLang: true,
                jaClass: 'jaLang',
                enClass: 'enLang',
                types: [
                    {id: TYPE_KYC_PASSPORT, name: 'passport'},
                    {id: TYPE_KYC_DRIVER_LICENSE, name: 'driver_license'},
                    {id: TYPE_KYC_ID_CARD, name: 'id_card'},
                ],
            }
        },
        async created(){
            this.fetchStatus()
            this.lang()
        },

        async updated(){
            //本人確認写真を確認中の場合
            if(this.status == KYC_SETTINGS_CONFIRM || this.status == KYC_SETTINGS_RE_UPLOAD){
                document.getElementById('color-confirm').style.backgroundColor = KYC_COLOR_WHITE　//本人確認を申請する背景色
                document.getElementById("passportVal").setAttribute("disabled", true); //旅券番号テキストエリア　disabled化
            }else{
                document.getElementById('color-confirm').style.backgroundColor = KYC_COLOR_PURPLE //本人確認を申請する背景色
            }
        },

        watch: {
            '$i18n.locale': function(locale) {
                this.lang()
            },
            'formData.type'(newVal, oldVal) {
                this.formData.files = {
                    file1: null,
                    file2: null
                }
                if (newVal != oldVal) {
                    if (this.$refs.file1) {
                        this.$refs.file1.value = null;
                    }
                    if (this.$refs.file2) {
                        this.$refs.file2.value = null;
                    }
                    if (this.kycStatus == KYC_SETTINGS_UPLOAD || this.kycStatus == KYC_SETTINGS_NON_APPROVAL) {
                        this.formData.passport_number = '';
                        this.idImageData1 = image;
                        this.idImageData2 = image;
                    }
                    this.errors = this.getDefaultFields;
                    this.chk = false;
                }
            }
        },

        methods: {
            consts() {
                return {
                    STATUS_APPROVED: '2',
                }
            },

            clicked(chk) {
                if(!chk){
                    //チェックボックス　オン
                    document.getElementById("disabledChk").disabled = false
                    document.getElementById("disabledChk").style.backgroundColor = KYC_COLOR_DARK_PURPLE
                }else{
                    //チェックボックス　オフ
                    document.getElementById("disabledChk").disabled = true
                    document.getElementById("disabledChk").style.backgroundColor = KYC_COLOR_GRAY
                }
            },

            mouseOverAction(){
                if (this.formData.type == null) {
                    return;
                }
                document.getElementById("disabledChk").style.backgroundColor = KYC_COLOR_DEEP_PURPLE
            },

            mouseLeaveAction(){

                if (!this.chk) {
                    document.getElementById("disabledChk").style.backgroundColor = KYC_COLOR_GRAY
                } else {
                    document.getElementById("disabledChk").style.backgroundColor = KYC_COLOR_DARK_PURPLE
                }
            },

            getDefaultFields() {
                return {
                    files: {
                        file1: null,
                        file2: null,
                    },
                    input_file: '',
                    passport_number: '',
                    type: null
                }
            },

            handleOnChangeFileInput(e, refName) {
                const file = this.$refs[refName].files[0];
                const input = e.target;

                this.formData.files[refName] = file;

                const checkOut = document.getElementById('checkout');
                const buttonDisabled = document.getElementById('disabledChk');

                if (file) {
                    if (file.size > config.kycFileSizeMax) {
                        console.log(refName)
                        this.errors = {
                            ...this.errors,
                            [`files.${refName}`]: 'FILE_SIZE_EXCEEDED'
                        };

                        console.log(this.errors);

                        checkOut.checked = false;
                        checkOut.disabled = true;
                        buttonDisabled.disabled = true;
                        buttonDisabled.style.backgroundColor = KYC_COLOR_GRAY;

                    } else {
                        this.errors = {
                            ...this.errors,
                            [`files.${refName}`]: ''
                        };

                        checkOut.checked = false;
                        checkOut.disabled = false;
                        this.chk = false;

                        buttonDisabled.disabled = true;
                        buttonDisabled.style.backgroundColor = KYC_COLOR_GRAY;

                        const reader = new FileReader();
                        reader.onload = (e) => {
                            if (refName === 'file1') {
                                this.idImageData1 = e.target.result;
                            } else {
                                this.idImageData2 = e.target.result;
                            }
                        };
                        reader.readAsDataURL(file);
                    }

                }
            },
            async handleOnSubmit() {
                this.errors = this.getDefaultFields();
                try {
                    const result = await kycService.uploadKyc(this.formData);
                    //リダイレクト　完了画面
                    this.$router.push('/kyc-settings-complete')
                } catch (err) {
                    this.errors = this.getDefaultFields();
                    if (err.response && err.response.data) {
                        if (err.response.data.errors) {
                            err.response.data.errors.forEach(errItem => {
                                if (errItem.field) {
                                    this.errors[errItem.field] = errItem.message[0];
                                }
                                if (errItem.field == 'files.file1' || errItem.field == 'files.file2' || errItem.field == 'files') {
                                    this.errorsFile = true
                                }
                            })
                        }
                    }else{

                    }
                }
            },
            async fetchStatus() {
                try{
                    const result = (await kycService.getStatus()).data
                    this.resultData = result
                    this.resultStatus = result.status
                    this.getStatus = true
                }catch{
                    this.getStatus = false
                }
                if(this.getStatus){
                    //本人確認状況ステータス：承認済み
                    if(Number(this.resultStatus) == KYC_SETTINGS_APPROVAL){
                        //リダイレクト ログイン後トップ
                        this.$router.push('/')
                    }else{
                        this.initStatus(this.resultData)
                    }
                }else{
                    this.kycStatus = KYC_SETTINGS_UPLOAD
                    this.initStatus()
                }
            },
            initStatus(kycsettings) {

                if (kycsettings) {
                    this.kycStatus = Number(kycsettings.status) //本人確認状況:ステータス
                    this.formData.passport_number = this.asterisk(kycsettings.passport_number) //旅券番号アスタリスク
                    if(this.kycStatus == KYC_SETTINGS_UPLOAD || this.kycStatus == KYC_SETTINGS_NON_APPROVAL ){
                        this.formData.passport_number = '' //旅券番号
                    }
                    this.idImageData1 = kycsettings.images[0];
                    this.idImageData2 = kycsettings.images[1] ? kycsettings.images[1] : image;
                    this.formData.type = Number(kycsettings.type);
                    if( Number(kycsettings.status) == KYC_SETTINGS_NON_APPROVAL){
                        this.kycStatus = KYC_SETTINGS_NON_APPROVAL //非承認です。再度写真をアップロードしてください
                        this.formData.passport_number  = ''
                        this.idImageUpData = false
                        this.idImageData = image
                    }
                } else {
                    this.kycStatus = KYC_SETTINGS_UPLOAD //本人確認状況:ステータス
                    this.formData.passport_number  = ''
                    this.idImageUpData = false
                    this.idImageData = image
                }

                this.status = this.kycStatus
                this.isLoaded = true;
            },
            //旅券番号アスタリスク化
            asterisk(passport_number)
            {
                if (!passport_number) {
                    return passport_number
                }
                let num  = Number(passport_number.toString().length)
                let nums = num - KYC_ASTERISK_NUM
                let passport_numbers = String(passport_number)
                let number = ''

                if(num <= KYC_ASTERISK_NUM){
                    return passport_numbers
                }else{
                    number = "*".repeat(nums) + passport_numbers.slice(-KYC_ASTERISK_NUM)
                    return number
                }
            },
            //半角英数字のみ入力
            onInput() {
                this.formData.passport_number = this.formData.passport_number.replace(/[^0-9a-zA-Z]+/g,'')
            },
            //言語切替(画像：ステップ2 & ステップ3)
            lang(){
                let lang = languageService.getCurrentLanguageShortCode();
                if(lang == 'en') {
                    this.isLang = false
                    this.idImageStepData2 = idStep2en
                    this.idImageStepData4 = idStep4en
                    this.langs = true
                }else if(lang == 'ja') {
                    this.isLang = true
                    this.idImageStepData2 = idStep2ja
                    this.idImageStepData4 = idStep4ja
                    this.langs = false
                }
            },
        }
    }
</script>

<style scoped>
    .how-to1 {
        white-space: pre-wrap;
        background-color: #f5f5f5;
        margin-bottom: 20px;
        padding: 10px;
    }

    .btn {
        cursor: pointer;
    }

    .how-to2 {
        white-space: pre-wrap;
    }

    .document-preview img {
        padding: 10px;
    }

    .upload-btn-wrapper {
        position: relative;
        overflow: hidden;
        display: inline-block;
        width: 175px;
    }

    .upload-btn-wrapper .btn {
        margin: 0 auto;
    }

    .upload-btn-wrapper:hover {
        cursor: pointer;
    }

    .upload-btn-wrapper input[type=file] {
        font-size: 100px;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
    }

    .chkImage1 {
        position: relative;
    }

    .chkImage1 p {
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%,-50%);
        -webkit-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
        margin:0;
        padding:0;
        text-align: center
    }

    .chkImage1 img {
        width: 50%;
    }
    .chkImage2 {
        position: relative;
    }

    .chkImage2 p {
        max-width: 250px;
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%,-50%);
        -webkit-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
        margin:0;
        padding:0;
        text-align: center
    }
    .titleSubLabel {
        font-size: 17px;
        margin-top: 5px;
        margin-bottom: 15px;
    }
    .text_area{
        color:#69D3A9;
        font-size:50px;
    }
    .apply{
        margin-bottom: 5px;
    }
    .checkbox{
        margin-top:30px;
        margin-bottom: 5px;
    }

    .chkCol{
        display: inline-block;
        border-bottom-width: 0px;
        border-top-width: 0px;
        border-left-width: 0px;
        border-right-width: 0px;
        padding: 20px 40px;
        line-height: 1;
        color: #fff;
        background-color: #c6c6c6;
        text-decoration: none;
        border-radius: 60px; /* 角丸設定 */
        width:170px;
    }
    button:focus {
        outline: none;
    }
    /* レイアウト */
    .custom-select-purple {
        border: 2px solid #7b2cbf !important;
        color: #000;
        padding-right: 40px;
        background-color: #fff;

        -webkit-appearance: none !important;
        -moz-appearance: none !important;
        appearance: none !important;
        background-image: none !important;
    }
    .custom-select-purple:focus {
        border-color: #a36cf5 !important;
        box-shadow: 0 0 0 0.2rem rgba(123, 44, 191, 0.25);
    }
    .custom-select-wrapper {
        position: relative;
        width: 250px;
    }
    .custom-select-wrapper svg {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
    }
    .custom-select-purple option {
        padding: 10px;
    }
    .kyc_label_top {
        background-color: #7D34AD;/* 背景色指定 */
        color:#FFF;
    }
    .kyc_label {
        background-color: #7D34AD;/* 背景色指定 */
        padding-left: 7px;
        padding-right: 7px;
        margin: -1px -1px 1px -1px;
        color:#FFF;
    }
    .kyc_labelEall {
        background-color: #7D34AD;/* 背景色指定 */
        padding-top: 5px;
        padding-left: 10px;
        padding-right: 10px;
        padding-bottom: 5px;
        margin: -1px -1px 1px -1px;
        color:#FFF;
    }
    .kyc_labelE1 {
        background: linear-gradient(180deg, #7D34AD 0%, #7D34AD 75%, #fff 50%, #fff 100%);
        padding-top: 5px;
        padding-left: 10px;
        padding-right: 10px;
        padding-bottom: 5px;
        margin: -1px 0px 0px 0px;
        color:#FFF;
    }
    .kyc_labelE4 {
        background: linear-gradient(180deg, #7D34AD 0%, #7D34AD 75%, #fff 50%, #fff 100%);
        padding-top: 5px;
        padding-left: 10px;
        padding-right: 10px;
        padding-bottom: 5px;
        margin: -1px -1px 1px 0px;
        color:#FFF;
    }
    .kyc_status1 {
        width:350px;
        margin:auto;
        padding:1px;
        text-align:center;
    }
    .kyc_status2 {
        padding-left: 7px;
        font-weight: bold;
    }
    .caution {
        margin-bottom: 40px;
    }
    .menu1 {
        display: flex;
        border: 2px solid #7D34AD;
    }
    .menu2 {
        display: flex;
    }
    .menu3 {
        display: flex;
        border-bottom: none;
    }
    .menu3 img{
        width:50%;
        padding:5% 25%;
    }
    .menu4 {
        border-top: 4px solid #7D34AD;
    }
    .menu5 {
        border: none;
    }
    .centering_item1 {
        max-width: 450px; /*幅指定 */
        margin:  0 auto;/* 中央寄せ */
    }
    .centering_item2 {
        margin:  0 auto;/* 中央寄せ */
    }
    .centering_item3{
        border: 4px solid #7D34AD;
        margin:0 auto;
        max-width: 400px;
    }
    .centering_item4 {
        max-width: 520px; /* 幅指定 */
        margin:  0 auto;/* 中央寄せ */
    }
    .kyc-Manual1 {
        padding-top: 20px;
        padding-bottom: 0px;
    }
    .kyc-Manual2 {
        padding-bottom: 10px;
    }
    .delete-updown {
        padding-top: 0px;
        padding-bottom: 0px;
    }
    .border-line {
        border-top: solid 2px #7D34AD;
        width: 35px;
        margin: auto;
        margin-top: 3px;
        margin-bottom: 5px;
    }

    .img-btn {
        max-width: 25px;
    }
    .caution-manual {
        margin-bottom: 30px;
    }
    .cation-label {
        flex-shrink: 0;
        width: 30px;
    }
    .col-text {
        color: #9056BA;
    }
    .outer{
        text-align: center;
    }
    .inner{
        display: inline-block;
        text-align: left;
    }
    .center{
        text-align: center !important;
    }
    .form-control1 {
        height: calc(1.6em + 0.75rem + 2px);
        padding: 0.375rem 0.75rem;
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 1.6;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    .colorfilter-base {
        background-color: #350F71;  /* カラーフィルタ効果の色を指定 */
        display: inline-block;  /* (任意：インラインブロック化したい場合) */
    }
    .colorfilter-image {
        opacity: 0.6;    /* カラーフィルタ効果の度合いを指定 */
        display: block;
    }
    .btn-size{
        width: 175px;
        height: 40px;
    }
    .fontSize1{
        font-size: 18px;
    }
    .titleSub{
        padding-bottom: 10px;
    }
    .fontSize2{
        font-size: 17px;
    }
    .fontSizeErr{
        font-size: 80%;
        color: #e3342f;
        text-align: center;
    }
    .fontSizeErrEnd{
        font-size: 80%;
        color: #e3342f;
        text-align: center;
        padding-bottom: 10px;
    }
    .btn-disabled:hover {
        padding-left: 1px !important;
        background-color: #c6c6c6 !important;
        color: #9056BA !important;
        cursor: not-allowed !important;
    }
    .jaLang{
        width:110px;
        text-align: center;
    }
    .enLang{
        width:200px;
        text-align: center;
    }
    select:disabled,
    input:disabled {
        background-color: #c6c6c6;
        opacity: 1;
    }

    select:disabled {
        background-color: #c6c6c6;
        opacity: 1;
        border: 1px #6c757d solid !important;
    }
    .btn-disabled {
        background-color: #c6c6c6 !important;
        color: #9056BA !important;
        border: 1px #6c757d solid !important;
        cursor: not-allowed !important;
    }
    .pre {
        white-space: pre-line;
    }
    /*スマホ用css*/
    @media screen and (max-width: 430) {
        .fontSize1{
            font-size: 18px;
        }
        .fontSize2{
            font-size: 17px;
        }
        .fontSizeErr{
            font-size: 80%;
            color:#e3342f;
            text-align: center;
        }
        .fontSizeErrEnd{
            font-size: 80%;
            color:#e3342f;
            text-align: center;
            padding-bottom:10px;
        }
    }
    @media screen and (max-width: 380px) {
        .kyc_label1{
            font-size: 24px;
        }
        .centering_item {
            width: 330px; /*幅指定 */
        }
        .fontSize1{
            font-size: 18px;
        }
        .fontSize2{
            font-size: 17px;
        }
        .fontSizeErr{
            font-size: 80%;
            color:#e3342f;
            text-align: center;
        }
        .fontSizeErrEnd{
            font-size: 80%;
            color:#e3342f;
            text-align: center;
            padding-bottom:10px;
        }
        .jaLang{
            width:160px;
        }
        .enLang{
            width:310px;
        }
    }
</style>
